var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "77px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#9b9797",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,27.18V52.76a2.92,2.92,0,0,1-3,2.84H15a2.92,2.92,0,0,1-3-2.84V27.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.26 55.52 26.26 38.45 37.84 38.45 37.84 55.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44,19.18s-1.1,7.76,6.45,8.94a7.17,7.17,0,0,0,6.1-2A7.43,7.43,0,0,0,32,26a7.4,7.4,0,0,0,5,2.49,11.82,11.82,0,0,0,5.9-2.15,6.66,6.66,0,0,0,4.67,2.15,8,8,0,0,0,7.93-9.3L50.78,9.05a1,1,0,0,0-.94-.65H14a1,1,0,0,0-.94.66Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.44,
    y1: 19.18,
    x2: 55.54,
    y2: 19.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.04,
    y1: 19.18,
    x2: 21.04,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.05,
    y1: 19.18,
    x2: 32.05,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.01,
    y1: 19.18,
    x2: 43.01,
    y2: 8.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.98578970bb53f7ef0d9a2d03fed323ed.svg";
export { ForwardRef as ReactComponent };